module.exports = __webpack_public_path__ + "media/images/ceremony/plans/2/hall-list/plan-ceremony-lineup-tokai-1-7bfa1475702f732545a0e393bea09874.png";